import { useTranslation } from 'react-i18next';
import { getLocale, formatDateLong } from '../../../helpers/dates';
import { format } from 'date-fns';
import styles from './SummaryTransfer.module.css';
import StretchIcon from '../../../components/icons/StretchIcon';
import PointStartIcon from '../../../components/icons/PointStartIcon';
import PointEndIcon from '../../../components/icons/PointEndIcon';
import ArrowRightIcon from '../../../components/icons/ArrowRightIcon';
import AirplaneIcon from '../../../components/icons/AirplaneIcon';
import ClockIcon from '../../../components/icons/ClockIcon';
import Box from '../../Box/Box';
import { CalendarIcon } from 'lucide-react';

const SummaryTransfer = ({ transfers, lng }) => {
  const { t } = useTranslation();
  const locale = getLocale(lng);

  if (!transfers || transfers.length === 0) return null;

  const renderTripCard = (trip, title, isOutbound) => {
    const isAirportPickup = isOutbound
      ? trip.fromPointType === 'AIRPORT'
      : trip.toPointType === 'AIRPORT';

    return (
      <Box>
        <div>
          {/* <div className={styles.headerIcon}>
            <StretchIcon />
          </div> */}
          <div className='section-title'>{title}</div>
        </div>

        <div className={`${styles.routeContainer} mt-3`}>
          <div className={styles.routeColumn}>
            <div
              className='text-secondary font-smaller fw-400 d-flex align-items-center'
              style={{ gap: '5px' }}
            >
              {t('transfer.from')}
            </div>
            <div className={styles.routePoint}>
              <PointStartIcon size={16} />
              <span className='fw-600 font-tiny'>{trip.fromPickupName}</span>
            </div>
          </div>

          <div className={styles.routeLine}>
            <ArrowRightIcon className={styles.arrowIcon} />
          </div>

          <div className={styles.routeColumn}>
            <div
              className='text-secondary font-smaller fw-400 d-flex align-items-center'
              style={{ gap: '5px' }}
            >
              {t('transfer.to')}
            </div>
            <div className={styles.routePoint}>
              <PointEndIcon size={16} />
              <span className='fw-600 font-tiny'>{trip.toPickupName}</span>
            </div>
          </div>
        </div>

        <div className='mt-4'>
          {isAirportPickup && trip.airline && trip.flightNumber ? (
            <div className={styles.detailItem}>
              <div className={styles.detailContent}>
                <span className='text-secondary font-smaller fw-400 d-flex align-items-center'>
                  {isOutbound ? t('transfer.arrivalFlight') : t('transfer.departureFlight')}
                </span>

                <div>
                  <div className='fw-600 font-tiny'>
                    {trip.airline} · #{trip.flightNumber}
                  </div>
                  <div className='fw-500 font-tiny text-lighter-gray mt-1'>
                    {formatDateLong(trip.transferDate, locale)}
                  </div>
                  <div className='fw-500 font-tiny text-lighter-gray mt-1'>
                    {format(new Date(trip.transferDate), 'h:mm aaa', { locale })}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className={styles.detailItem}>
              <div className={styles.detailContent}>
                <span className='text-secondary font-smaller fw-400 d-flex align-items-center'>
                  {t('transfer.pickupDateTime')}
                </span>
                <div>
                  <div className='fw-600 font-tiny'>
                    {/* <CalendarIcon size='16' color={'var(--color-primary)'} /> */}
                    {formatDateLong(trip.transferDate, locale)}
                  </div>
                  <div className='fw-500 font-tiny text-lighter-gray mt-1'>
                    {/* <ClockIcon size='16' color={'var(--color-primary)'} /> */}
                    {format(new Date(trip.transferDate), 'h:mm aaa', { locale })}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </Box>
    );
  };

  return (
    <div>
      {transfers[0] && renderTripCard(transfers[0], t('transfer.outboundTransfer'), true)}
      <div className='mt-2'>
        {transfers[1] && renderTripCard(transfers[1], t('transfer.inboundTransfer'), false)}
      </div>
    </div>
  );
};

export default SummaryTransfer;
